var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMythicalS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48486 1.70793H3.5187V1H8.48487V1.70793H9.19279V3.84595H8.61293V3.84931H3.32658V3.84595H2.81075V1.70793H3.51868V3.14138H8.48486V1.70793ZM3.51511 7.38881V9.51615H4.23014V8.81214H4.93809V9.51615H4.94521V10.2209H5.64957V9.53047H6.35752V10.2209H7.04765V9.51615H7.05119V8.81567H4.94163V8.10775H7.05121V8.81218H7.75914V9.51615H8.48126V10.2241H7.76982V10.9288H4.22662V10.2241H3.51155V9.52683H2.80718V7.38881H3.51511ZM9.19279 9.52683L9.19279 7.3893H9.90072V4.55732H11V3.84939H9.90072V3.84606H9.19279L9.19279 3.84939V4.55414H2.80718V3.84606H2.09926V3.84939H1V4.55732H2.09926V7.38925H2.80718V5.26207H9.19279L9.19279 7.38881H8.48486V9.52683H9.19279ZM5.27605 6.6808H6.73103V7.38881H8.15045V6.6808H8.15047V5.97287H3.86018V6.26821H3.85664V7.38881H5.27605V6.6808Z",
    fill: "#FFD747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMythicalS);
export default __webpack_public_path__ + "static/media/mythical-s.0d66c9de7c01cda763896a7073da703c.svg";
export { ForwardRef as ReactComponent };